import style from "./style.module.scss";
import AiWidgetIcon from "@assets/icons/ai-widget-icon.svg";

export const ChatBotAvatar = () => {
  return (
    <div className={style.avatar}>
      <img
        src={AiWidgetIcon}
        alt="AI Assistant"
        className={style.avatar__image}
      />
    </div>
  );
};
